import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, BadgeCheckIcon } from 'lucide-react';
import { TESTIMONIALS } from '../constants/content';
import { StarRating } from './StarRating';
export function SocialProof() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-255" data-mp="36xend3wqe9uq">
      <div className="mx-auto max-w-5xl px-4" data-id="element-256" data-mp="3btvb3x00qm7a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-10 text-center" data-id="element-257" data-mp="3bwr89j41l6uo">
          <h2 className="font-display text-3xl font-700 leading-tight text-ink sm:text-4xl" data-id="element-258" data-mp="3usr4x77ysykl">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-gray-600" data-id="element-259" data-mp="mbmleus0ijdh">
            No quiero que te quedes solo con mi palabra. Mirá lo que cuentan
            algunos de los que ya usan Pollería Rentable 2026:
          </p>
        </motion.div>

        {/* Masonry via CSS columns */}
        <div className="columns-1 gap-6 sm:columns-2 [&>*]:mb-6" data-id="element-260" data-mp="1pcl3nb0ffomy">
          {TESTIMONIALS.map((t, i) => <motion.figure key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="break-inside-avoid rounded-2xl bg-cream p-6 shadow-sm ring-1 ring-black/5" data-id="element-261" data-mp="241qyynw58upk" data-mpi={i}>
              <QuoteIcon className="mb-3 h-8 w-8 text-gold" aria-hidden="true" data-id="element-262" data-mp="slah6nx4a1zj" />
              <StarRating className="mb-3" size={16} data-id="element-263" data-mp="nnhdc1jadk2f" />
              <figcaption className="mb-2 font-display text-lg font-600 text-crimson" data-id="element-264" data-mp="1dalfgnwxs1vb">
                «{t.title}»
              </figcaption>
              <blockquote className="mb-5 text-base leading-relaxed text-gray-800" data-id="element-265" data-mp="1hd80o5z3qojj">
                «{t.quote}»
              </blockquote>
              <div className="flex items-center gap-3" data-id="element-266" data-mp="1r9ukcrfoz9jz">
                <img src={t.img} alt={`Foto de ${t.name}`} width={48} height={48} loading="lazy" decoding="async" className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-gold/40" data-id="element-267" data-mp="1r78b8nd5klzn" />
                <div data-id="element-268" data-mp="29zj7hydaxlos">
                  <p className="font-700 text-ink" data-id="element-269" data-mp="29yrd2qvfxu03">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-270" data-mp="2eyvymvb7hex6">{t.location}</p>
                </div>
                <BadgeCheckIcon className="ml-auto h-5 w-5 text-green-600" aria-label="Compra verificada" data-id="element-271" data-mp="2ex2qfbky2mn2" />
              </div>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}